import type { ReactNode } from 'react';

interface AuthFormLayoutProps {
    children: ReactNode;
    title: string;
    subtitle?: ReactNode;
}

export function AuthFormLayout({
    children,
    title,
    subtitle,
}: AuthFormLayoutProps) {
    return (
        <>
            <div className="mb-8 space-y-2">
                <h2 className="text-2xl font-bold">{title}</h2>
                {subtitle && (
                    <p className="text-muted-foreground">{subtitle}</p>
                )}
            </div>
            {children}
        </>
    );
}
